import Button from "@mui/material/Button";
import { FeatureFlagKey } from "encamp-shared/src/featureFlags";
import { useFeatureFlags } from "hooks/useFeatureFlags";
import { useLocalStorageState } from "hooks/useLocalStorageState";

export const VENDOR_DASHBOARD_STORAGE_KEY = "waste-manifests-vendor-dashboard-open";

export function VendorDashboardToggle() {
  // Customer-visible on manifest-views-v2 tenants (staff resolve that flag on
  // via its staff override); epa-correction gates the underlying data, so the
  // dashboard never renders empty. Mirrors the canReadCorrectionStats authorizer.
  const { featureFlags } = useFeatureFlags();
  const enabled =
    !!featureFlags[FeatureFlagKey.ManifestViewsV2] &&
    !!featureFlags[FeatureFlagKey.WasteEpaCorrectionDiscrepancies];

  const [open, setOpen] = useLocalStorageState<boolean>(VENDOR_DASHBOARD_STORAGE_KEY, {
    defaultValue: true,
  });

  if (!enabled) {
    return null;
  }

  return (
    <Button onClick={() => setOpen(!open)} variant="text">
      {open ? "Hide Vendor Stats" : "Show Vendor Stats"}
    </Button>
  );
}
